import { httpClient } from '../client';
import { LoginResponse, UserInfoResponse, EventIdResponse } from './types';
import { getBrand } from 'utils/platformStyle';

export * from './types';

let pendingGetEventId: Promise<EventIdResponse> | null = null;

export class AuthApi {
  async checkConnection(): Promise<any> {
    // 使用 getEventId API 來檢查連線
    try {
      await this.getEventId();
      return { success: true };
    } catch (error: any) {
      if (error?.errorCode || error?.code) {
        return { success: true };
      }
      console.error("Network connection failed:", error);
      throw error;
    }
  }

  async login(eventId: string, email: string, password: string): Promise<LoginResponse> {
    const brand = getBrand();
    return httpClient.post<LoginResponse>(
      '/volunteer/login',
      {
        email,
        password,
      },
      {
        eventId,
        brand,
        platform: 'pwa',
      }
    );
  }

  async logout(): Promise<any> {
    return httpClient.post('/account/logout', {});
  }

  async getEventId(): Promise<EventIdResponse> {
    if (pendingGetEventId) {
      return pendingGetEventId;
    }

    pendingGetEventId = httpClient.get<EventIdResponse>(
      '/flagbageasy/flagbagvolunteer/event',
      {},
    ).finally(() => {
      pendingGetEventId = null;
    });

    return pendingGetEventId;
  }

  // 用于在登录后获取用户id
  async getUserInfo(eventId: string): Promise<UserInfoResponse> {
    return httpClient.get('/volunteer/profile', {
      eventId,
    });
  }
}

export const authApi = new AuthApi();
